import { apiClient } from '@/api/client'
import type {
  ConsumoIA,
  ConsumoIACreateInput,
  ConsumoIAFilters,
  ConsumoIAUpdateInput,
  ResumenProveedor,
} from '../types/consumoIA'

const BASE = '/consumo-ia'

export async function getConsumoIA(filters?: ConsumoIAFilters): Promise<ConsumoIA[]> {
  const { data } = await apiClient.get<ConsumoIA[]>(`${BASE}/`, { params: filters })
  return data
}

export async function getResumenProveedor(filters?: ConsumoIAFilters): Promise<ResumenProveedor> {
  const { data } = await apiClient.get<ResumenProveedor>(`${BASE}/resumen/`, { params: filters })
  return data
}

export async function createConsumoIA(payload: ConsumoIACreateInput): Promise<ConsumoIA> {
  const { data } = await apiClient.post<ConsumoIA>(`${BASE}/`, payload)
  return data
}

export async function updateConsumoIA(id: number, payload: ConsumoIAUpdateInput): Promise<ConsumoIA> {
  const { data } = await apiClient.put<ConsumoIA>(`${BASE}/${id}/`, payload)
  return data
}
